import { getCountryCurrencyCode } from '@/utils/money';
import {
  SalesPortalRestaurantFieldsFragment,
  SalesPortalSupplierFieldsFragment,
} from '@/types';
import { SearchableDropdownMenuItemData } from '@usepepper/ui/molecules/searchable-dropdown-menu';

export type RestaurantListData = SearchableDropdownMenuItemData<{
  chatUUID: string;
  currencyCode: string;
  onHold: boolean;
  restaurantAddress: string;
  restaurantName: string;
  restaurantTimezone: string;
  supplierTimezone: string;
  supplierUUID: string;
}>;

interface SalesPortalRestaurantInput {
  chatUUID: string;
  onHold: boolean;
  restaurant: SalesPortalRestaurantFieldsFragment;
  supplier: SalesPortalSupplierFieldsFragment;
}

/**
 * Transforms a account/chat row to the sales-portal `RestaurantListData` shape.
 *
 * @param {SalesPortalRestaurantInput} input - Normalized restaurant/supplier
 *   fields (chat id, on-hold, name, address, timezones) to transform.
 *
 * @returns {RestaurantListData} The tranformed `RestaurantListData` row data.
 */
export const salesPortalRestaurantRowTransformer = (
  input: SalesPortalRestaurantInput,
): RestaurantListData => ({
  chatUUID: input.chatUUID,
  currencyCode: getCountryCurrencyCode(input.supplier.address.country_code),
  key: input.restaurant.uuid,
  onHold: input.onHold,
  restaurantAddress: input.restaurant.address.address,
  restaurantName: input.restaurant.name,
  restaurantTimezone: input.restaurant.address.timezone,
  supplierTimezone: input.supplier.address.timezone,
  supplierUUID: input.supplier.uuid,
});
